import { useContext, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import { toast } from "react-hot-toast";
import ajaxMeeting from "../../util/remote/ajaxMeeting";

const AddMinutes = (props) => {
  const [loading, setLoading] = useState(false);
  const [meeting_title, setMeetingTitle] = useState("");
  const [additional_file, setAdditionalFile] = useState("");
  const [minutes, setMinutes] = useState("");
  const [date_held, setDateHeld] = useState("");
  const [type, setType] = useState("");

  // Handle adding a new meeting
  const handleAdd = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (
      meeting_title.length > 0 &&
      date_held.length > 0 &&
      minutes.length > 0 && // Ensure minutes file is selected
      additional_file.length > 0 // Ensure additional file is selected
    ) {
      let data = {
        meeting_title: meeting_title,
        minutes: minutes,
        type: type,
        date_held: date_held,
        additional_file: additional_file,
      };

      setLoading(true);

      // Make server request to create the meeting
      const server_response = await ajaxMeeting.createMeeting(data);
      setLoading(false);

      if (server_response.status === "OK") {
        // Reset state after successful submission
        setMeetingTitle("");
        setDateHeld("");
        setType("");
        setMinutes("");
        setAdditionalFile("");
        toast.success(server_response.message);
        props.f(); // Callback function to refresh the parent component
      } else {
        toast.error(server_response.message);
      }
    } else {
      toast.error("Complete all fields and try again");
    }
  };

  // Handle minutes document file change
  const changeMinutesDoc = (e) => {
    e.preventDefault();
    let files = e.target.files;
    let reader = new FileReader();
    reader.readAsDataURL(files[0]); // Reading the first file

    reader.onload = (e) => {
      setMinutes(e.target.result); // Set minutes file as base64
    };
  };

  // Handle additional file change
  const changeAdditionalFile = (e) => {
    e.preventDefault();
    let files = e.target.files;
    let reader = new FileReader();
    reader.readAsDataURL(files[0]); // Reading the first file

    reader.onload = (e) => {
      setAdditionalFile(e.target.result); // Set additional file as base64
    };
  };

  // Render the footer (buttons) in the modal
  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}>
            Close
          </button>
          <button
            type="button"
            className={`btn ripple btn-success`}
            onClick={handleAdd}>
            Save Minutes
          </button>
        </>
      );
    }
  };

  return (
    <SystemModal
      title="Register Meeting Minutes"
      id="model-new-meeting"
      size="md"
      footer={RenderFooter}>
      <div className="mb-4">
        <label htmlFor="">Meeting Title</label>
        <input
          type="text"
          value={meeting_title}
          onChange={(e) => setMeetingTitle(e.target.value)}
          className="form-control"
        />
      </div>
      <div className="mb-4">
        <label htmlFor="">Meeting Type</label>
        <input
          type="text"
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="form-control"
        />
      </div>
      <div className="mb-4">
        <label>
          <b>Minutes Document </b>
        </label>
        <input
          type="file"
          onChange={(e) => changeMinutesDoc(e)}
          multiple
          className="form-control"
        />
      </div>
      <div className="mb-4">
        <label>
          <b>Additional file </b>
        </label>
        <input
          type="file"
          onChange={(e) => changeAdditionalFile(e)}
          multiple
          className="form-control"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="">Meeting Date</label>
        <input
          type="date"
          value={date_held}
          onChange={(e) => setDateHeld(e.target.value)}
          className="form-control"
        />
      </div>
    </SystemModal>
  );
};

export default AddMinutes;
